import React from "react";
import { Quote, Star } from "lucide-react";

const REVIEWS = [
  {
    name: "Sarah M.",
    location: "Mt Eliza, VIC",
    project: "84m Timber Paling",
    quote:
      "Dan turned up when he said, finished a day early, and the fence is dead straight. Best tradie experience we've had — full stop.",
  },
  {
    name: "Mark D.",
    location: "Pakenham, VIC",
    project: "Colorbond + Sliding Gate",
    quote:
      "Quoted on a Friday, started the next Tuesday. No mess, no nonsense. The motorised gate works flawlessly six months on.",
  },
  {
    name: "Linda & Pete",
    location: "Cowes, VIC",
    project: "Pool Compliance + Aluminium",
    quote:
      "Got us through pool certification first time. Crew was respectful around the kids and dogs. Worth every cent.",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative bg-[#1A1A1A] py-24 lg:py-32 border-t border-[#222] overflow-hidden grain"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="text-xs tracking-[0.3em] uppercase text-[#FF5A00] font-bold mb-4">
              [ 03 ] What Locals Say
            </div>
            <h2 className="font-heading uppercase text-white text-5xl lg:text-7xl leading-[0.9] tracking-tighter">
              Five Stars.<br />
              <span className="text-[#FF5A00]">No Cousins.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-3">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 fill-[#FF5A00] text-[#FF5A00]" />
              ))}
            </div>
            <p className="text-[#A3A3A3] text-lg">
              Averaging 4.9 across 80+ verified Google reviews — straight from
              real homeowners and site managers in your suburb.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-[#333]">
          {REVIEWS.map((r, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-[#0D0D0D] p-8 lg:p-10 flex flex-col gap-6 hover:-translate-y-1 transition-transform"
            >
              <Quote className="w-10 h-10 text-[#FF5A00]" strokeWidth={1} />
              <p className="text-white text-lg leading-relaxed font-body">
                "{r.quote}"
              </p>
              <div className="mt-auto pt-6 border-t border-[#333]">
                <div className="font-heading text-white text-xl uppercase tracking-tight">
                  {r.name}
                </div>
                <div className="text-xs tracking-[0.2em] uppercase text-[#A3A3A3] mt-1">
                  {r.location} · {r.project}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
